"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;var _objectSpread2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/objectSpread2"));















var _vuex = require("vuex"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { props: { // departmentValue: {
    //   type: Array,
    //   default: () => []
    // }
    // 使用{}不报错：[Vue warn]: Invalid prop: type check failed for prop "departmentValue". Expected Object, got Array
    departmentValue: {} }, data: function data() {return { mechanism: [], // 并没有什么作用，使用props中的departmentValue作为父组件传递过来的变量即可
      defaultProps: { children: 'child', label: 'insName', value: 'id', checkStrictly: true, // 是否严格的遵守父子节点不互相关联
        emitPath: false, // 在选中节点改变时，是否返回由该节点所在的各级菜单的值所组成的数组，若设置 false，则只返回该节点的值
        expandTrigger: 'hover' } };}, computed: (0, _objectSpread2.default)({},
  (0, _vuex.mapGetters)({
    departmentList: 'departmentList' })),


  watch: {
    departmentValue: 'changeValue' },

  created: function created() {
    this.departmentList.length === 0 ? this.getAddress() : '';
  },
  mounted: function mounted() {
    // this.meChanism.length === 0 ? this.getAddress() : ''
  },
  methods: {
    changeValue: function changeValue() {
      this.departmentValue = this.departmentValue;
    },
    getAddress: function getAddress() {
      var self = this;
      self.getData('/api/institution/dropList/0', {}, function (res) {
        self.$store.dispatch('mechanism/setDepartmentList', res);
      });
    },
    changeAddress: function changeAddress(val) {
      this.$emit('relDepartment', val);
    } } };exports.default = _default;